import { mpfRListsHttp } from '../api/mpf-r-lists-http'
import { PersonDetails } from './inquiry/inquiry'

interface SiteFeedback {
  Description: string
  FeedbackAbout: string
  ItemCreated: Date
  ItemCreatedBy: PersonDetails | string
  'ItemCreatedBy/edipi'?: string
  'ItemCreatedBy/email'?: string
  'ItemCreatedBy/firstname'?: string
  'ItemCreatedBy/lastname'?: string
  ItemModified: Date
  ItemModifiedBy: PersonDetails | string
  'ItemModifiedBy/edipi'?: string
  'ItemModifiedBy/email'?: string
  'ItemModifiedBy/firstname'?: string
  'ItemModifiedBy/latname'?: string
  Title: string
  UserRole: string
  eKey?: string
  eTag?: string
}
interface SiteFeedbackArgs {
  isAscending?: boolean
  orderBy?: string
}
const COLUMN_NAMES = {
  Description: 'Description',
  ETag: 'eTag',
  Ekey: 'eKey',
  FeedbackAbout: 'FeedbackAbout',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemCreatedByEDIPI: 'ItemCreatedBy/edipi',
  ItemCreatedByEmail: 'ItemCreatedBy/email',
  ItemCreatedByFirstName: 'ItemCreatedBy/firstname',
  ItemCreatedByLastName: 'ItemCreatedBy/lastname',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  ItemModifiedByEDIPI: 'ItemModifiedBy/edipi',
  ItemModifiedByEmail: 'ItemModifiedBy/email',
  ItemModifiedByFirstName: 'ItemModifiedBy/firstname',
  ItemModifiedByLastName: 'ItemModifiedBy/lastname',
  Title: 'Title',
  UserRole: 'UserRole',
}
const LIST_NAME = 'SiteFeedbackList'

const getSiteFeedback = async (args?: SiteFeedbackArgs): Promise<SiteFeedback[]> => {
  const list = await mpfRListsHttp().getList(LIST_NAME)
  const orderBy = args?.orderBy ?? COLUMN_NAMES.ItemCreated
  const ascending = args?.isAscending ?? false
  const items = await list
    .query()
    .select(...Object.values(COLUMN_NAMES))
    .expand(
      COLUMN_NAMES.ItemCreatedBy,
      COLUMN_NAMES.ItemModifiedBy,
    )
    .orderBy([{ ascending, orderBy }])
    .get()
    return [...items] as SiteFeedback[]
}
const addOrUpdateSiteFeedBack = async (addObj: SiteFeedback): Promise<SiteFeedback | undefined> => {
  try {
    const siteFeedBackList = await mpfRListsHttp().getList(LIST_NAME)
    return await siteFeedBackList.addOrUpdateItem(addObj)
  } catch (error) {
    console.error('Error in addOrUpdateSiteFeedBack:', error)
    throw error
  }
}

export {
  COLUMN_NAMES,
  LIST_NAME,
  type SiteFeedback,
  type SiteFeedbackArgs,
  addOrUpdateSiteFeedBack,
  getSiteFeedback,
}
